import {
  Box,
  Button,
  HStack,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Tag,
  Text,
  VStack,
} from '@chakra-ui/react';

import Link from '@/components/Link';
import { POLYGON, POLYGON_SUNSET_OVERLAY } from '@/constants/constants';
import { env } from '@/env';

const DiscontinuedOverlay = () => {
  if (env.NEXT_PUBLIC_TOKEN !== POLYGON) {
    return null;
  }

  return (
    <Modal
      isOpen
      onClose={() => undefined}
      isCentered
      closeOnOverlayClick={false}
    >
      {/* Soft dimmed + blurred backdrop — landing stays visible behind */}
      <ModalOverlay bg="rgba(20, 37, 40, 0.32)" backdropFilter="blur(8px)" />

      {/* Light, on-brand card */}
      <ModalContent
        mx={4}
        maxW="440px"
        bg="white"
        borderRadius="24px"
        boxShadow="0 24px 64px rgba(20, 37, 40, 0.18)"
        overflow="hidden"
      >
        <ModalBody p={{ base: 6, md: 8 }}>
          <VStack spacing={5} textAlign="center">
            {/* Branding */}
            <HStack spacing={2}>
              <Image
                src="/assets/images/stader-icon.svg"
                boxSize="22px"
                alt="Stader"
              />
              <Text fontWeight={700} fontSize="16px" color="textPrimary">
                Stader
              </Text>
            </HStack>

            {/* Network mark */}
            <Box p={3} borderRadius="full" bg="#F4F8F6">
              <Image
                src="/assets/images/sidebar/polygon_light.svg"
                boxSize="56px"
                alt={POLYGON_SUNSET_OVERLAY.network}
              />
            </Box>

            {/* Status pill */}
            <Tag bg="#FDECEC" color="#C0341D" borderRadius="full" px={3} py={1}>
              <Text
                fontSize="10px"
                fontWeight={700}
                letterSpacing="0.6px"
                textTransform="uppercase"
              >
                {POLYGON_SUNSET_OVERLAY.badge}
              </Text>
            </Tag>

            <VStack spacing={2}>
              <Text
                fontSize="24px"
                fontWeight={800}
                color="textPrimary"
                lineHeight="1.25"
              >
                {POLYGON_SUNSET_OVERLAY.title}
              </Text>
              <Text fontSize="15px" color="textSecondary" maxW="330px">
                {POLYGON_SUNSET_OVERLAY.description}
              </Text>
            </VStack>

            <HStack spacing={3} pt={2} w="full" justify="center">
              <Button
                as="a"
                href={POLYGON_SUNSET_OVERLAY.learnMoreUrl}
                target="_blank"
                rel="noreferrer"
                variant="outline"
              >
                {POLYGON_SUNSET_OVERLAY.learnMoreText}
              </Button>
              <Link link={POLYGON_SUNSET_OVERLAY.unstakeUrl}>
                <Button bg="primary !important" color="white">
                  {POLYGON_SUNSET_OVERLAY.unstakeText}
                </Button>
              </Link>
            </HStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default DiscontinuedOverlay;
